const eventHandlers = (state, setState) => {
  const refreshTable = () =>
    setState(newState => ({
      ...newState,
      forceReload: !state.forceReload,
      openSidePanel: false,
    }));

  const onClose = () => {
    setState(newState => ({ ...newState, openSidePanel: false }));
  };

  const toggleDrawer = (open, rowData) => {
    setState(newState => ({ ...newState, openSidePanel: open, groupId: rowData[0], selectedGroup: rowData }));
  };

  return {
    refreshTable,
    toggleDrawer,
    onClose,
  };
};

export default eventHandlers;
